import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 pt-16 pb-24 md:pb-8 border-t border-slate-800" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-48">
          {/* Brand Info */}
          <div className="space-y-6" data-id="element-49">
            <Link to="/" className="flex items-center gap-3" data-id="element-50">
              <div className="bg-white p-1 rounded-full inline-block" data-id="element-51">
                <img src="https://cdn.magicpatterns.com/uploads/njJUJ1uVWXUUEU8dnak6Jg/Screenshot_2025-12-23-16-07-24-10_99c04817c0de5652397fc8b56c3b3817.png" alt="Sky Brand" className="h-10 w-auto rounded-full" data-id="element-52" />
              </div>
              <span className="font-bold text-2xl tracking-tight text-white" data-id="element-53">
                SKY BRAND
              </span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-54">
              Premium clothing for the modern individual. We believe in quality,
              comfort, and style that stands the test of time.
            </p>
            <div className="flex gap-4" data-id="element-55">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-sky-600 hover:text-white transition-colors" data-id="element-56">
                <InstagramIcon className="w-5 h-5" data-id="element-57" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-sky-600 hover:text-white transition-colors" data-id="element-58">
                <FacebookIcon className="w-5 h-5" data-id="element-59" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-sky-600 hover:text-white transition-colors" data-id="element-60">
                <TwitterIcon className="w-5 h-5" data-id="element-61" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-62">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-63">
              Shop
            </h3>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <Link to="/products?category=Shirts" className="hover:text-sky-400 transition-colors" data-id="element-66">
                  Men's Shirts
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/products?category=T-Shirts" className="hover:text-sky-400 transition-colors" data-id="element-68">
                  T-Shirts
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/products?category=Jeans" className="hover:text-sky-400 transition-colors" data-id="element-70">
                  Denim Jeans
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/products?category=Jackets" className="hover:text-sky-400 transition-colors" data-id="element-72">
                  Winter Jackets
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/products?category=Hoodies" className="hover:text-sky-400 transition-colors" data-id="element-74">
                  Cozy Hoodies
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/products" className="hover:text-sky-400 transition-colors text-sky-500" data-id="element-76">
                  View All Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div data-id="element-77">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-78">
              Customer Service
            </h3>
            <ul className="space-y-3" data-id="element-79">
              <li data-id="element-80">
                <Link to="/my-orders" className="hover:text-sky-400 transition-colors" data-id="element-81">
                  Track Order
                </Link>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-83">
                  Returns & Exchanges
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-85">
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-87">
                  Size Guide
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-89">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-90">
            <h3 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm" data-id="element-91">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-92">
              <li className="flex items-start gap-3" data-id="element-93">
                <MapPinIcon className="w-5 h-5 text-sky-500 shrink-0 mt-0.5" data-id="element-94" />
                <span className="text-sm" data-id="element-95">
                  123 Fashion Street, Sector 14,
                  <br data-id="element-96" />
                  New Delhi, 110001, India
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-97">
                <PhoneIcon className="w-5 h-5 text-sky-500 shrink-0" data-id="element-98" />
                <span className="text-sm" data-id="element-99">+91 98765 43210</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-100">
                <MailIcon className="w-5 h-5 text-sky-500 shrink-0" data-id="element-101" />
                <span className="text-sm" data-id="element-102">support@skybrand.com</span>
              </li>
            </ul>

            <div className="mt-8" data-id="element-103">
              <h4 className="text-sm font-medium text-white mb-3" data-id="element-104">
                Subscribe to our newsletter
              </h4>
              <form className="flex" onSubmit={e => e.preventDefault()} data-id="element-105">
                <input type="email" placeholder="Your email address" className="bg-slate-800 border-none rounded-l-lg px-4 py-2 w-full focus:ring-1 focus:ring-sky-500 outline-none text-sm text-white" data-id="element-106" />
                <button type="submit" className="bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded-r-lg text-sm font-medium transition-colors" data-id="element-107">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-108">
          <p className="text-sm text-slate-500" data-id="element-109">
            &copy; {new Date().getFullYear()} Sky Brand. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-110">
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}